theme.headerSearch = (function () {
  function searchOverlay() {
    const drawer = document.getElementById("predictive__search_overlay");
    if (!drawer || drawer.dataset.searchBound) return;
    drawer.dataset.searchBound = "true";
    let opener;
    const close = () => {
      if (!drawer.classList.contains("active")) return;
      drawer.classList.remove("active");
      document.body.classList.remove("added__overlay_search");
      opener.setAttribute("aria-expanded", "false");
      removeTrapFocus(opener);
    };
    document.querySelectorAll(".header__actions_btn--search").forEach(trigger => {
      trigger.setAttribute("aria-expanded", "false");
      trigger.setAttribute("aria-controls", drawer.id);
      trigger.addEventListener("click", event => {
        event.preventDefault();
        opener = trigger;
        drawer.classList.add("active");
        document.body.classList.add("added__overlay_search");
        trigger.setAttribute("aria-expanded", "true");
        const focusSearch = () => {
          if (drawer.classList.contains("active")) trapFocus(drawer, drawer.querySelector('input[type="search"]'));
        };
        drawer.addEventListener("transitionend", focusSearch, { once: true });
        requestAnimationFrame(focusSearch);
      });
    });
    drawer.addEventListener("keydown", event => {
      if (event.key === "Escape") close();
    });
    document.getElementById("search__close_btn").addEventListener("click", close);
    document.addEventListener("click", event => {
      if (!event.target.closest("#predictive__search_overlay, .header__actions_btn--search")) close();
    });
  }
  return searchOverlay;
})();
